import {YandexMapHelper} from "./yandex-map-helper";
import {YANDEX_LANG} from "./constants";

const LOAD_SCRIPT = document.createElement( `script` );

let ymapsObject = window.ymaps;

const checkMapProps = ( mapProps ) => {
	const {
		ymapsApiKey,
		readyCallback,
		mapContainer,
		component,
	} = mapProps;

	const checkResult = {
		status: true,
		error: null,
	};

	const getErrorResult = ( message ) => {
		checkResult.status = false;
		checkResult.error = new Error( message );

		return checkResult;
	};

	if ( !ymapsApiKey || typeof ymapsApiKey !== `string` ) {
		return getErrorResult( `Некорретный ключ API` );
	}

	if ( !readyCallback || !( readyCallback instanceof Function ) )
	{
		return getErrorResult( `readyCallback не является функцией` );
	}

	if ( !mapContainer ) {
		return getErrorResult( `Контейнер карты отсутствует` );
	}

	if ( !component ) {
		return getErrorResult( `Компонент не задан` );
	}

	return checkResult;
};

const invokeCallbackAfterApiReady = ( mapProps ) => {
	ymapsObject.ready( () => {
		mapProps.readyCallback( new YandexMapHelper( ymapsObject, mapProps ) );
	} );
};

const createYandexMapHelper = ( mapProps ) => {
	const {
		ymapsApiKey,
		ymapsApiLang = YANDEX_LANG.RU,
	} = mapProps;
	
	const checkResult = checkMapProps( mapProps );

	if ( !checkResult.status )
	{
		throw checkResult.error;
	}

	if ( ymapsObject )
	{
		invokeCallbackAfterApiReady( mapProps );
	}
	else
	{
		if ( !document.head.contains( LOAD_SCRIPT ) )
		{
			/* УДАЛИТЬ debug */
			LOAD_SCRIPT.src = `https://api-maps.yandex.ru/2.1/?apikey=${ymapsApiKey}&lang=${ymapsApiLang}`;
			document.head.appendChild( LOAD_SCRIPT );
		}

		LOAD_SCRIPT.addEventListener( `load`, () => {
			if ( window.ymaps )
			{
				ymapsObject = window.ymaps;

				invokeCallbackAfterApiReady( mapProps );
			}
		} );
	}
};

export {
	createYandexMapHelper,
};
